export default {
  title: 'Programa de fidelización',
};
